import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuizForm } from './hooks/useQuizForm'
import {QuizResponse} from './components/QuizResponse'
import {QuizProgress} from './components/QuizProgress'
import {QuizResult} from './components/QuizResult'
import {QuizTitle} from './components/QuizTitle'
import {QuizCustomNode} from './components/QuizCustomNode'
import './quiz.scss'
import { useRecoilValue } from 'recoil';
import {isQuizSaved, quizLoaded} from './states/quizState'
import { useTranslations } from 'hooks';
import { EcoSpinner } from 'components';

/**
 * 
 * description
 * 
 * ###Import to use it
 *
 *```jsx
 *   import { QuizForm } from '@eco/react-lib'
 *```
 *
 *### Usage
 *
 *```jsx
 *<QuizForm 
 *   label={string} 
 *   isSubmit={boolean} 
 *   disabled={boolean}
 />
 *```
 *
 *### Basic Example
 */

export const QuizForm = ({route, quizName, registrationUrl, customNodes, id, userId}: QuizFormType): JSX.Element => {

    const { id: stepId } = useParams();
    const navigate = useNavigate()
    const [customNodeName, setCustomNodeName] = useState<string | undefined>(undefined)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const { handleRespond, 
        meta, 
        events, 
        currentPosition, 
        currentState, 
        handleClear, 
        handleBack, 
        defaultResponse, 
        stepLeft, 
        isfinalState } = useQuizForm(quizName, route, stepId, id, userId)
    const [TITLE, BACK] = useTranslations(i18n(currentState))
    const quizLoad = useRecoilValue(quizLoaded)
    const isSaved = useRecoilValue(isQuizSaved)

    useEffect(() => {
        if(currentPosition != undefined) {
            setCustomNodeName(meta?.customNode && meta?.customNode != '' ? meta?.customNode : undefined)
        }
    }, [events, meta, currentPosition])

    useEffect(() => {
        if(isfinalState && registrationUrl && !isSaved) {
            navigate(`${registrationUrl}`, {replace: true})
        }
    }, [isfinalState, registrationUrl, isSaved])

    useEffect(() => {
        setIsLoading(stepLeft != undefined ? false : true)
    },[stepLeft])

    if(isfinalState && registrationUrl && !isSaved) {
        return (<></>)
    }

    return (
        <>
            {
                isLoading  
                ? <div className="quizSpinner"><EcoSpinner style={{ fontSize: 128 }} /></div>
                : <div className="quizForm">
                    <div className="quizForm-sideBar">
                        <QuizProgress total={quizLoad.depth|| 0} stepLeft={stepLeft || 0} onStart={() => handleClear()}/>
                    </div>
                    <div className="quizForm-body">
                        <div className='quizTopHeader'>
                            <Button onClick={() => handleBack()} className="backButton">{BACK}</Button>
                        </div>
                        {!customNodeName && <QuizTitle title={TITLE} /> }
                        {customNodeName && customNodes
                            && <QuizCustomNode componentName={customNodeName} components={customNodes} metaData={{...meta, on: events}} onRespond={handleRespond}/> }
                        {
                            !customNodeName && !isfinalState
                            && <QuizResponse
                            defaultResponse={defaultResponse}
                            events={events}
                            meta={meta}
                            onRespond={handleRespond}/>
                        } 
                        {
                            !customNodeName && isfinalState && <QuizResult description={meta?.description} img="/assets/img/b-12.png"/>
                        }
                        
                    </div>
                </div> 
            }
        </>
    )
}

type QuizFormType = {
    userId?: string
    id?: string
    route: string
    quizName: string
    registrationUrl?: string
    customNodes?: Record<string, JSX.Element>
}

const i18n = (key?: string) => [
    `MedicalDevice.${key}.text`,
     `MedicalDevice.Back.button`
]